import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: ({ status }) => {
      switch (status) {
        case 'success':
          return theme.palette.success.main
        case 'info':
          return '#1facd8'
        case 'error':
          return theme.palette.error.main
        case 'secondary':
          return theme.palette.secondary.main
        case 'light':
          return '#ececec'
        case 'dark':
          return '#d7d9dba8'
        case 'primary':
          return '#143A5F'
        default:
          return theme.palette.info.main
      }
    },
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ({ size }) => {
      switch (size) {
        case 'large':
          return '8px 20px'
        case 'small':
          return '0 8px'
        default:
          return '5px 9px'
      }
    },
    borderRadius: ({ borderRadius }) => {
      return borderRadius + 'px'
    },
    color: ({ color }) => color,
    fontWeight: 'bold',
  },
  text: {
    flexShrink: 0,
  },
}))

const Pill = ({
  id,
  value,
  status,
  size = 'medium',
  borderRadius = 20,
  color = 'white',
  ...rest
}) => {
  const classes = useStyles({ status, size, borderRadius, color })

  if (value == null) return null

  return (
    <div key={id} className={classes.root} {...rest}>
      <Typography variant="caption" className={classes.text}>
        {value}
      </Typography>
    </div>
  )
}

export default Pill
